import Address               from "../../../domain/fundamentals/address/Address";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Email                 from "../../../domain/fundamentals/email/Email";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Office                from "../../../domain/office/Office";
import OfficeId              from "../../../domain/office/OfficeId";
import OfficeName            from "../../../domain/office/OfficeName";
import OfficeNameKana        from "../../../domain/office/OfficeNameKana";
import OfficeRepository      from "../../../domain/office/OfficeRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import OfficeDataSource      from "../../../infrastructure/datasource/office/OfficeDataSource";

class GetOffice {
  constructor(
    private readonly dispatch,
    private readonly officeRepository: OfficeRepository = new OfficeDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.officeRepository.find();
      const office: Office = new Office(
        new OfficeId(response.data.id),
        new OfficeName(response.data.name),
        new OfficeNameKana(response.data.name_kana),
        new Email(response.data.email_address),
        new Address(
          new PostalCode(response.data.address.postal_code),
          new Prefecture(response.data.address.prefecture),
          new City(response.data.address.city),
          new Street(response.data.address.street),
          new Building(response.data.address.building)
        )
      );
      this.officeRepository.setOffice(office);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetOffice;
